export var FileType;
(function (FileType) {
    FileType["Resume"] = "resume";
    FileType["ProgramDocument"] = "program_document";
    FileType["ProgramRequirementAttachment"] = "program_requirement_attachment";
    FileType["ProgramApplicationRequirement"] = "program_application_requirement";
})(FileType || (FileType = {}));
export var ProgramRequirementType;
(function (ProgramRequirementType) {
    ProgramRequirementType["Link"] = "link";
    ProgramRequirementType["Document"] = "document";
    ProgramRequirementType["Resume"] = "resume";
})(ProgramRequirementType || (ProgramRequirementType = {}));
export var CompanyType;
(function (CompanyType) {
    CompanyType["Unknown"] = "Unknown";
    CompanyType["Hospital"] = "Hospital";
    CompanyType["School"] = "School";
    CompanyType["PrivatePractice"] = "PrivatePractice";
    CompanyType["College"] = "College";
    CompanyType["SelfEmployed"] = "SelfEmployed";
    CompanyType["Franchise"] = "Franchise";
    CompanyType["Government"] = "Government";
    CompanyType["Public"] = "Public";
    CompanyType["OtherOrganization"] = "OtherOrganization";
    CompanyType["Nonprofit"] = "Nonprofit";
    CompanyType["Contract"] = "Contract";
    CompanyType["Private"] = "Private";
    CompanyType["Subsidiary"] = "Subsidiary";
})(CompanyType || (CompanyType = {}));
export var EmployerSize;
(function (EmployerSize) {
    EmployerSize["Unknown"] = "Unknown";
    EmployerSize["Size_1To_50"] = "Size_1_to_50";
    EmployerSize["Size_51To_200"] = "Size_51_to_200";
    EmployerSize["Size_201To_500"] = "Size_201_to_500";
    EmployerSize["Size_501To_1000"] = "Size_501_to_1000";
    EmployerSize["Size_1001To_5000"] = "Size_1001_to_5000";
    EmployerSize["Size_5001To_10000"] = "Size_5001_to_10000";
    EmployerSize["Size_10000Plus"] = "Size_10000_Plus";
})(EmployerSize || (EmployerSize = {}));
export var InstitutionSectorEnum;
(function (InstitutionSectorEnum) {
    InstitutionSectorEnum["AdministrativeUnit"] = "AdministrativeUnit";
    InstitutionSectorEnum["PublicFourOrMoreYears"] = "PublicFourOrMoreYears";
    InstitutionSectorEnum["PrivateNonprofitFourOrMoreYears"] = "PrivateNonprofitFourOrMoreYears";
    InstitutionSectorEnum["PrivateForprofitFourOrMoreYears"] = "PrivateForprofitFourOrMoreYears";
    InstitutionSectorEnum["PublicTwoYears"] = "PublicTwoYears";
    InstitutionSectorEnum["PrivateNonprofitTwoYears"] = "PrivateNonprofitTwoYears";
    InstitutionSectorEnum["PrivateForprofitTwoYears"] = "PrivateForprofitTwoYears";
    InstitutionSectorEnum["PublicLessThanTwoYears"] = "PublicLessThanTwoYears";
    InstitutionSectorEnum["PrivateNonprofitLessThanTwoyears"] = "PrivateNonprofitLessThanTwoyears";
    InstitutionSectorEnum["PrivateForprofitLessThanTwoyears"] = "PrivateForprofitLessThanTwoyears";
    InstitutionSectorEnum["Unknown"] = "Unknown";
})(InstitutionSectorEnum || (InstitutionSectorEnum = {}));
export var InstitutionLevelEnum;
(function (InstitutionLevelEnum) {
    InstitutionLevelEnum["FourOrMoreYears"] = "FourOrMoreYears";
    InstitutionLevelEnum["LessThanFourYears"] = "LessThanFourYears";
    InstitutionLevelEnum["LessThanTwoYears"] = "LessThanTwoYears";
    InstitutionLevelEnum["NotAvailable"] = "NotAvailable";
})(InstitutionLevelEnum || (InstitutionLevelEnum = {}));
export var HighestLevelOfferingEnum;
(function (HighestLevelOfferingEnum) {
    HighestLevelOfferingEnum["Other"] = "Other";
    HighestLevelOfferingEnum["PostsecondaryLessThanOneYear"] = "PostsecondaryLessThanOneYear";
    HighestLevelOfferingEnum["PostsecondaryLessThanTwoYears"] = "PostsecondaryLessThanTwoYears";
    HighestLevelOfferingEnum["Associate"] = "Associate";
    HighestLevelOfferingEnum["PostsecondaryLessThanFourYears"] = "PostsecondaryLessThanFourYears";
    HighestLevelOfferingEnum["Bachelor"] = "Bachelor";
    HighestLevelOfferingEnum["PostbaccalaureateCertificate"] = "PostbaccalaureateCertificate";
    HighestLevelOfferingEnum["Master"] = "Master";
    HighestLevelOfferingEnum["PostMaster"] = "PostMaster";
    HighestLevelOfferingEnum["Doctor"] = "Doctor";
    HighestLevelOfferingEnum["NotApplicable"] = "NotApplicable";
    HighestLevelOfferingEnum["NotAvailable"] = "NotAvailable";
})(HighestLevelOfferingEnum || (HighestLevelOfferingEnum = {}));
export var UserRole;
(function (UserRole) {
    UserRole["Recruiter"] = "recruiter";
    UserRole["Student"] = "student";
    UserRole["Advisor"] = "advisor";
    UserRole["Guest"] = "guest";
    UserRole["System"] = "system";
})(UserRole || (UserRole = {}));
export var SkillSubtype;
(function (SkillSubtype) {
    SkillSubtype["Soft"] = "soft";
    SkillSubtype["Hard"] = "hard";
    SkillSubtype["Major"] = "major";
})(SkillSubtype || (SkillSubtype = {}));
export var SalaryRangeEnum;
(function (SalaryRangeEnum) {
    SalaryRangeEnum["Low"] = "low";
    SalaryRangeEnum["Median"] = "median";
    SalaryRangeEnum["High"] = "high";
})(SalaryRangeEnum || (SalaryRangeEnum = {}));
export var Gender;
(function (Gender) {
    Gender["Male"] = "male";
    Gender["Female"] = "female";
    Gender["Unknown"] = "unknown";
})(Gender || (Gender = {}));
export var DegreeLevel;
(function (DegreeLevel) {
    DegreeLevel["Certificate"] = "certificate";
    DegreeLevel["Associates"] = "associates";
    DegreeLevel["AssociatesBachelors"] = "associates_bachelors";
    DegreeLevel["NurseProgram"] = "nurse_program";
    DegreeLevel["Bachelors"] = "bachelors";
    DegreeLevel["Doctoral"] = "doctoral";
    DegreeLevel["Masters"] = "masters";
    DegreeLevel["MastersDoctoral"] = "masters_doctoral";
    DegreeLevel["Undecided"] = "undecided";
    DegreeLevel["AdvancedCertificate"] = "advanced_certificate";
    DegreeLevel["HighSchoolOrGed"] = "high_school_or_ged";
    DegreeLevel["PostDoctoral"] = "post_doctoral";
})(DegreeLevel || (DegreeLevel = {}));
export var UserJobStatus;
(function (UserJobStatus) {
    UserJobStatus["GotAJob"] = "GotAJob";
    UserJobStatus["LookingForAJob"] = "LookingForAJob";
})(UserJobStatus || (UserJobStatus = {}));
export var ProgramQuestionType;
(function (ProgramQuestionType) {
    ProgramQuestionType["Radio"] = "radio";
    ProgramQuestionType["Text"] = "text";
    ProgramQuestionType["Checkbox"] = "checkbox";
    ProgramQuestionType["Textarea"] = "textarea";
})(ProgramQuestionType || (ProgramQuestionType = {}));
export var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus["Draft"] = "Draft";
    ApplicationStatus["Pending"] = "Pending";
    ApplicationStatus["Approved"] = "Approved";
    ApplicationStatus["Rejected"] = "Rejected";
})(ApplicationStatus || (ApplicationStatus = {}));
export var ProgramEmploymentType;
(function (ProgramEmploymentType) {
    ProgramEmploymentType["HireInterns"] = "hire_interns";
    ProgramEmploymentType["FulltimeRole"] = "fulltime_role";
})(ProgramEmploymentType || (ProgramEmploymentType = {}));
export var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus["Draft"] = "draft";
    ProgramStatus["Pending"] = "pending";
    ProgramStatus["Archived"] = "archived";
    ProgramStatus["Active"] = "active";
    ProgramStatus["ActiveApplying"] = "active_applying";
    ProgramStatus["ActiveRecruiting"] = "active_recruiting";
    ProgramStatus["Closed"] = "closed";
})(ProgramStatus || (ProgramStatus = {}));
export var CampaignInviteFeedbackOfferStep;
(function (CampaignInviteFeedbackOfferStep) {
    CampaignInviteFeedbackOfferStep["Offer"] = "Offer";
    CampaignInviteFeedbackOfferStep["Screening"] = "Screening";
    CampaignInviteFeedbackOfferStep["Interview"] = "Interview";
    CampaignInviteFeedbackOfferStep["AcceptedInvitation"] = "AcceptedInvitation";
    CampaignInviteFeedbackOfferStep["GotAJob"] = "GotAJob";
    CampaignInviteFeedbackOfferStep["NotInterested"] = "NotInterested";
})(CampaignInviteFeedbackOfferStep || (CampaignInviteFeedbackOfferStep = {}));
export var CampaignInviteFeedbackOfferStatus;
(function (CampaignInviteFeedbackOfferStatus) {
    CampaignInviteFeedbackOfferStatus["Accepted"] = "Accepted";
    CampaignInviteFeedbackOfferStatus["Rejected"] = "Rejected";
    CampaignInviteFeedbackOfferStatus["NoResponse"] = "NoResponse";
})(CampaignInviteFeedbackOfferStatus || (CampaignInviteFeedbackOfferStatus = {}));
export var CampaignInviteStatus;
(function (CampaignInviteStatus) {
    CampaignInviteStatus["Pending"] = "pending";
    CampaignInviteStatus["Accepted"] = "accepted";
    CampaignInviteStatus["Rejected"] = "rejected";
})(CampaignInviteStatus || (CampaignInviteStatus = {}));
export var CampaignInviteRejectionReason;
(function (CampaignInviteRejectionReason) {
    CampaignInviteRejectionReason["NotInterested"] = "not_interested";
    CampaignInviteRejectionReason["GotJob"] = "got_job";
})(CampaignInviteRejectionReason || (CampaignInviteRejectionReason = {}));
export var SkillType;
(function (SkillType) {
    SkillType["Normal"] = "NORMAL";
    SkillType["High"] = "HIGH";
})(SkillType || (SkillType = {}));
export var EmploymentType;
(function (EmploymentType) {
    EmploymentType["HireInterns"] = "hire_interns";
    EmploymentType["FulltimeRole"] = "fulltime_role";
})(EmploymentType || (EmploymentType = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["Active"] = "active";
    CampaignStatus["Draft"] = "draft";
    CampaignStatus["Closed"] = "closed";
    CampaignStatus["Pending"] = "pending";
    CampaignStatus["Rejected"] = "rejected";
})(CampaignStatus || (CampaignStatus = {}));
export var CampaignIncentiveType;
(function (CampaignIncentiveType) {
    CampaignIncentiveType["NoIncentive"] = "no_incentive";
    CampaignIncentiveType["AmazonGiftCard"] = "amazon_gift_card";
})(CampaignIncentiveType || (CampaignIncentiveType = {}));
export var CampaignHoursPerWeek;
(function (CampaignHoursPerWeek) {
    CampaignHoursPerWeek["Hours_1To_10"] = "Hours_1_to_10";
    CampaignHoursPerWeek["Hours_11To_20"] = "Hours_11_to_20";
    CampaignHoursPerWeek["Hours_21To_40"] = "Hours_21_to_40";
    CampaignHoursPerWeek["Hours_41Plus"] = "Hours_41_plus";
})(CampaignHoursPerWeek || (CampaignHoursPerWeek = {}));
export var OrderingDirection;
(function (OrderingDirection) {
    OrderingDirection["Asc"] = "ASC";
    OrderingDirection["Desc"] = "DESC";
})(OrderingDirection || (OrderingDirection = {}));
export var ApplicationStatusForSearch;
(function (ApplicationStatusForSearch) {
    ApplicationStatusForSearch["Pending"] = "Pending";
    ApplicationStatusForSearch["Approved"] = "Approved";
    ApplicationStatusForSearch["Rejected"] = "Rejected";
})(ApplicationStatusForSearch || (ApplicationStatusForSearch = {}));
//# sourceMappingURL=index.js.map